<template>
  <CallButton
    :tooltip-message="tooltipMessage"
    :disabled="callDisabled"
    @click="handleCall"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import CallButton from './CallButton.vue';
// import call from '@/assets/lottie/incoming_call.json'

export default defineComponent({
  components: {
    CallButton,
  },
  props: {
    phoneNumber: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('user', ['callTarget']),
    ...mapGetters('miitel', [
      'isCallable',
      'isCalling',
    ]),
    ...mapGetters('userUi', [
      'miitelWidgetVisible',
    ]),
    tooltipMessage(): string {
      if (!this.isValidPhoneNumber) {
        return this.$t('cti.invalidPhoneNumber');
      } else if (this.isCalling) {
        return this.$t('miitel.busy');
      } else if (this.callDisabled) {
        return this.$t('miitel.notStarted');
      } else {
        return this.$t('miitel.call');
      }
    },
    isValidPhoneNumber(): boolean {
      return typeof this.phoneNumber === 'string' && this.phoneNumber.length > 0;
    },
    callDisabled(): boolean {
      if (this.disabled) return true;
      return !this.isValidPhoneNumber || !this.miitelWidgetVisible || this.isCalling;
    },
  },
  methods: {
    handleCall(): void {
      if (this.callDisabled) {
        this.$toast.show({
          message: this.$t('miitel.notStarted'),
          type: 'error',
        });
        return;
      }

      // 発信
      window.miitelWidget.call(this.phoneNumber, {
        salesforce: {
          whtaId: this.callTarget?.sfRelatedLead?.sfAccountId,
          whoId: this.callTarget?.sfRelatedLead?.sfContactId ?? this.callTarget?.sfRelatedLead?.sfLeadId,
        },
      });
    },
  },
});
</script>
